/**
 * Route definitions for the User Management module.
 * Lazily loads the User Management page and pre-Raptor provision landing.
 * Keep provision route in sync with raptor-user-management-fe standalone `/user-management/provision`.
 * Tenant AppDefault.UrlUM must be `{feOrigin}/user-management/provision?embed=1`.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const UserManagementRoutes = createFeatureRoutes(
  'user-management',
  {
    list: () => import('../presentation/pages/UserManagementPage'),
    provision: () => import('../presentation/pages/ProvisionLandingPage')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'provision', pageKey: 'provision' }
  ]
);

export default UserManagementRoutes;
